<script>
  import { createEventDispatcher } from "svelte";
  import HotspotDescription from "./../HotspotDescription.svelte";
  import HotspotConnectionLine from "./HotspotConnectionLine.svelte";

  export let modelViewer = "";
  export let hotspot = "";
  export let backCopy = "";
  export let backArrow = "";
  export let model = "";
  export let lights = "";
  export let background = "";
  export let checkmark = "";
  export let blueCheckmark = "";

  export let zoomifyGlass = "";
  export let landscapeImg = "";
  export let zoomifyGlassShadow = "";

  let zoomScreenTL = new TimelineMax();
  let hotspotHoverTL = new TimelineMax();
  let hotspotRolloutTL = new TimelineMax();

  let showDescription = false;
  let id = -1;

  let modelTime = 0;
  const dispatch = createEventDispatcher();

  function isVisible() {
    dispatch("isVisible", true);
  }

  function openVideoHandler() {
    dispatch("open-video", {
      active: true,
      actualId: id,
    });
  }

  function showDescriptionHandler(elementId) {
    showDescription = true;
    id = elementId;
    clickHS(elementId);
  }

  function closeDescriptionHandler() {
    id = -1;
    showDescription = false;
    clickHS(id);
  }

  function clearAnimationHandler() {
    zoomScreenTL.pause("reset");
  }

  function animationZoomifyGlass() {
    zoomScreenTL = new TimelineMax();
    zoomScreenTL
      .add("reset")
      .from(
        glassContainer,
        0.3,
        { force3D: true, z: 0.01, opacity: 0, scaleX: 0, scaleY: 0, y: "120" },
        0.3
      )
      .to(glassContainer, 0.3, { force3D: true, scaleX: 1.2, scaleY: 1.2 }, 0.3)
      .to(
        glassContainer,
        0.3,
        { force3D: true, z: 0.01, opacity: 1, scaleX: 1, scaleY: 1, y: "0" },
        0.4
      )
      .add("slide")
      .to(glassContainer, 4, {  x: "-60" }, "slide")
      .to(EV_Inmersive, 4, {  x: "80" }, "slide");
  }

  function showAll() {
    let animation01 = document.getElementById("animation01");
    let animation02 = document.getElementById("animation02");
    let animation03 = document.getElementById("animation03");
    let animation04 = document.getElementById("animation04");
    let animation05 = document.getElementById("animation05");
    let animation06 = document.getElementById("animation06");

    animation01.setAttribute("data-visible", "");
    animation02.setAttribute("data-visible", "");
    animation03.setAttribute("data-visible", "");
    animation04.setAttribute("data-visible", "");
    animation05.setAttribute("data-visible", "");
    animation06.setAttribute("data-visible", "");

    animation01.setAttribute("style","display:visible;")
    animation02.setAttribute("style","display:visible;")
    animation03.setAttribute("style","display:visible;")
    animation04.setAttribute("style","display:visible;")
    animation05.setAttribute("style","display:visible;")
    animation06.setAttribute("style","display:visible;")
    let allBluecheckmark = document.getElementsByClassName("blue-checkmark");
    let allcheckmark = document.getElementsByClassName("white-checkmark");

    for (var i = 0, len = allBluecheckmark.length; i < len; i++) {
      allBluecheckmark[i].style.opacity = 0;
      allcheckmark[i].style.opacity = 1;
    }
  }

  function hoverHandler() {
    this.lastChild.style.color = "#ffffff";
    hotspotHoverTL = new TimelineMax();
    hotspotHoverTL
      .add("init")
      .to(
        this.getElementsByClassName("blue-checkmark"),
        0.2,
        { opacity: 1, scale: 1.2 },
        "init"
      )
      .to(
        this.getElementsByClassName("white-checkmark"),
        0.5,
        { opacity: 0, scale: 1, ease: Expo.easeOut },
        "init"
      );
    if (this.lastChild.classList.contains("hotspot-copy")) {
      hotspotHoverTL.to(
        this.lastChild,
        0.3,
        {
          background:
            "linear-gradient(90deg, rgba(0,0,0, 0.15) 0%, rgba(0,0,0,1) 90%)",
        },
        "init"
      );
    } else {
      hotspotHoverTL.to(
        this.lastChild,
        0.3,
        {
          background:
            "linear-gradient(90deg, rgba(0, 0, 0, 1) 50%, rgba(0, 0, 0, 0.15) 100%)",
        },
        "init"
      );
    }
  }

  function rollOutHandler() {
    if (this.lastChild.style) this.lastChild.style.color = "#dddddd";
    hotspotRolloutTL = new TimelineMax();
    hotspotRolloutTL
      .add("init")
      .to(
        this.getElementsByClassName("white-checkmark"),
        0.2,
        { opacity: 1, scale: 1 },
        "init"
      )
      .to(
        this.getElementsByClassName("blue-checkmark"),
        0.5,
        { opacity: 0, scale: 1.2, ease: Expo.easeOut },
        "init"
      );
    if (this.lastChild.classList && this.lastChild.classList.contains("hotspot-copy")) {
      hotspotRolloutTL.to(
        this.lastChild,
        0.3,
        {
          background:
            "linear-gradient(90deg, rgba(0, 0, 0, 0) 2%, rgba(0, 0, 0, 0.5) 40%)",
        },
        "init"
      );
    } else {
      hotspotRolloutTL.to(
        this.lastChild,
        0.3,
        {
          background:
            "linear-gradient(90deg, #000000 0%, rgba(0, 0, 0, 0.2) 100%",
        },
        "init"
      );
    }
  }

  function playRange(start, time) {
    let animationPause;

    modelViewer.play();
    modelViewer.currentTime = start;
    animationPause = setTimeout(function () {
      modelViewer.pause();
      open = false;
    }, time);
  }

  function clickHS(el) {
    // .style.cursor = "pointer";

    let animation01 = document.getElementById("animation01");
    let animation02 = document.getElementById("animation02");
    let animation03 = document.getElementById("animation03");
    let animation04 = document.getElementById("animation04");
    let animation05 = document.getElementById("animation05");
    let animation06 = document.getElementById("animation06");
    let hotspotCopy;

    clearAnimationHandler();
    showAll();
    modelViewer.resetTurntableRotation();
    modelViewer.autoRotate = false;
    modelViewer.cameraControls = false;
    modelViewer.fieldOfView = "40deg";
    modelViewer.cameraTarget="0m 25m 0m"

    switch (el) {
      case 0:
        //Wake in a flash
        hotspotCopy = 'Wake in a flash'
        modelViewer.cameraTarget="60m 15m -20m"
        modelViewer.cameraOrbit = "30deg 78deg 180m";
        playRange(19, 2000);
        animation02.setAttribute("style","display:none;")
        log2('media', '3d - ' + hotspotCopy);
        loggin('media', '3d - ' + hotspotCopy);
        break;
      case 1:
        //Immersive viewing
        modelViewer.cameraOrbit = "5deg 85deg 160m";
        modelViewer.cameraTarget="-15m 27.5m 10m"
        animationZoomifyGlass();
        playRange(7, 2000);
        animation01.setAttribute("style","display:none;")
        animation06.setAttribute("style","display:none;")
        animation05.setAttribute("style","display:none;")
        hotspotCopy = 'Immersive viewing'
        log2('media', '3d - ' + hotspotCopy);
        loggin('media', '3d - ' + hotspotCopy);
        break;
      case 2:
        //Get thing done fast 
        modelViewer.cameraOrbit = "00deg 10deg 160m";
        modelViewer.cameraTarget="30m 40m 0m"
        animation01.setAttribute("style","display:none;")
        animation02.setAttribute("style","display:none;")

        playRange(13, 2000);
        hotspotCopy = 'Get thing done fast'
        log2('media', '3d - ' + hotspotCopy);
        loggin('media', '3d - ' + hotspotCopy);
        break;
      case 3:
        //Unplug for longer
        modelViewer.cameraOrbit = "00deg 85deg 160m";
        modelViewer.cameraTarget="35m 27.5m 20m"

        animation01.setAttribute("style","display:none;")
        animation03.setAttribute("style","display:none;")

        playRange(2, 100);
        hotspotCopy = 'Unplug for longer'
        log2('media', '3d - ' + hotspotCopy);
        loggin('media', '3d - ' + hotspotCopy);
        break;
      case 4:
        //Fast, reliable connections
        modelViewer.cameraOrbit = "340deg 70deg 160m";
        modelViewer.cameraTarget="-35m 27.5m -15m"
        
        animation01.setAttribute("style","display:none;")
        animation02.setAttribute("style","display:none;")
        animation03.setAttribute("style","display:none;")
        animation06.setAttribute("style","display:none;")

        playRange(23, 2000);
        hotspotCopy = 'Fast, reliable connections'
        log2('media', '3d - ' + hotspotCopy);
        loggin('media', '3d - ' + hotspotCopy);
        break;
      case 5:
        //Universal cable connectivity
        playRange(2, 100);
        modelViewer.cameraOrbit = "300deg 75deg 160m";
        modelViewer.cameraTarget="-30m 27.5m -40m"
        animation02.setAttribute("style","display:none;")
        animation03.setAttribute("style","display:none;")
        animation05.setAttribute("style","display:none;")
        hotspotCopy = 'Universal cable connectivity'
        log2('media', '3d - ' + hotspotCopy);
        loggin('media', '3d - ' + hotspotCopy);
        break;
      default:
        console.log("default");
        modelViewer.cameraOrbit = "330deg 78deg 160m";
        modelViewer.cameraTarget="0m 27.5m 0m"
        modelViewer.autoRotate = true;
        modelViewer.cameraControls = true;
        playRange(2, 100);
        log2('media', 'elx 3d - back click');
        loggin('media', 'elx 3d - back click');
    }
  }

  (() => {
    let interval = self.setInterval(() => {
      modelTime = modelViewer.currentTime;
      if (modelViewer.currentTime >= 2) {
        modelViewer.pause();
        clearInterval(interval);
      }
    }, 100);
  })();
</script>

<style type="text/scss">
  #pageWrapper {
    height: 100%;
    width: 100%;
    overflow: hidden;
    background-color: #0a0909;
  }

  .ModeViewerHolder {
    display: block;
    text-align: center;
    margin: 0 auto;
    height: 100%;
    width: 100%;
    z-index: 1;
    opacity: 0;
    background-color: #000000 !important;
    background-repeat: no-repeat !important;
    background-size: cover !important;
    background-origin: content-box !important;
  }

  .model {
    background-repeat: no-repeat !important;
    background-size: cover !important;
    background-position: center 75% !important;
    display: block;
    text-align: center;
    margin: 0 auto;
    height: 100%;
    width: 100%;
    opacity: 0;
    
  }

  @media only screen and (min-height: 700px) {
  .model {
    max-height: 450px;
  }
}

@media only screen and (min-height: 725px) {
  .model {
    max-height: 475px;
  }
}

@media only screen and (min-height: 750px) {
  .model {
    max-height: 500px;
  }
}

@media only screen and (min-height: 775px) {
  .model {
    max-height: 525px;
  }
}

@media only screen and (min-height: 800px) {
  .model {
    max-height: 550px;
  }
}

@media only screen and (min-height: 825px) {
  .model {
    max-height: 575px;
  }
}

@media only screen and (min-height: 850px) {
  .model {
    max-height: 600px;
  }
}

@media only screen and (min-height: 875px) {
  .model {
    max-height: 625px;
  }
}
@media only screen and (min-height: 900px) {
  .model {
    max-height: 650px;
  }
}
@media only screen and (min-height: 925px) {
  .model {
    max-height: 675px;
  }
}

@media only screen and (min-height: 950px) {
  .model {
    max-height: 100%;
  }
}

@media only screen and (min-height: 1050px) {
  .model {
    height: 72% !important;
  }
}

@media only screen and (min-height: 1200px) {
  .model {
    height: 74% !important;
  }
}

@media only screen and (min-height: 1400px) {
  .model {
    height: 76% !important;
  }
}

@media only screen and (min-height: 1600px) {
  .model {
    height: 78% !important;
  }
}

@media only screen and (min-height: 2000px) {
  .model {
    height: 80% !important;
  }
}

  .hotspot {
    border-radius: 32px;
    background: transparent;
    border: 0;
    box-sizing: border-box;
    height: 44px;
    position: absolute;
    transition: opacity 0.3s;
    width: 44px;
    display: flex;
    cursor: pointer;

    pointer-events: none;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;

  }

  .hotspot-left {
    background: linear-gradient(90deg, #000000 0%, rgba(0, 0, 0, 0.2) 100%);
    text-align: right;
    left: -90%;
    word-break: break-all;
    padding-left: 10px;
    padding-right: 30px;
    background-position: revert;
    pointer-events: all;
    min-inline-size: max-content;
    position: relative;
    width: auto;
    height: auto;
    padding-top: 5px;
    padding-bottom: 5px;
    border-radius: 5px;
    top: 5px;
    color: white;
    white-space: nowrap;
    z-index: 2;
    font-size: 0.75rem;
  }

  .hotspot .circle {
    display: inline-block;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background-color: #1196cc;
    transform: scale(2);
    opacity: 0.1;
    position: absolute;
    top: -2px;
    left: -3px;
    z-index: -1;

  }

  .white-checkmark {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 42px;
    height: 42px;
    z-index: 4;
  }

  .blue-checkmark {
    pointer-events: none;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;

    opacity: 0;
    position: absolute;
    top: 0px;
    left: 0px;
    width: 42px;
    height: 42px;
    z-index: 5;
  }

  .hotspot .scale-in-center {
    animation: scale-in-center 1.6s cubic-bezier(0.25, 0.5, 0.5, 0.94) infinite;
  }

  .hotspot:not([data-visible]) {
    opacity: 0;
  }
  @keyframes scale-in-center {
    0% {
      transform: scale(0);
      opacity: 1;
    }
    60% {
      opacity: 1;
    }
    100% {
      transform: scale(1.1);
      opacity: 0.1;
    }
  }

  .hotspot-copy {
    background: linear-gradient(90deg, rgba(0, 0, 0, 0) 0%, #2b2b2b 50%);
    text-align: right;
    left: 20px;
    padding-left: 40px;
    padding-right: 10px;
    background-position: revert;
    pointer-events: all;
    min-inline-size: max-content;
    position: relative;
    width: auto;
    height: auto;
    padding-top: 5px;
    padding-bottom: 5px;
    border-radius: 5px;
    top: 5px;
    background-size: 100% 100%;
    color: white;
    white-space: nowrap;
    z-index: 2;
    font-size: 0.75rem;
  }

  #unit01 {
    z-index: 1;
    top: 9rem;
    height: 70%;
  }

  .noMouseInteraction {
    pointer-events: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .overlaysFXs {
    width: 100%;
    height: 100%;
    background-color: transparent;
    position: fixed;
    z-index: 30;
    top: 0;
    left: 0;
  }

  #glassContainer {
    position: absolute;
    top: 20%;
    left: 54.5%;
    opacity: 0;
    width: 110px;
    height: 135px;
    display: flex;
  }

  #shadow {
    position: absolute;
    width: 100%;
    height: 100%;
    left: -40px;
    top: -11px;
    display: none;
  }

  #EV_Inmersive {
    width: 230px;
    top: -10px;
    position: absolute;
    left: -120px;
  }

  #InmersiveContainer {
    position: absolute;
    width: 100%;
    height: 100%;
    -webkit-border-radius: 65px !important;
    -moz-border-radius: 65px !important;
    border-radius: 65px  !important;
    overflow: hidden;
    backface-visibility: hidden;
    -webkit-backface-visibility: hidden;
    -moz-backface-visibility: hidden;
    transform: translate3d(0, 0, 0);
    -webkit-transform: translate3d(0, 0, 0);
    -moz-transform: translate3d(0, 0, 0);
  }

  @media only screen and (max-height: 1100px) {
    #glassContainer {
      width: 96px;
      height: 120px;
    }

    #EV_lens {
      left: -62px !important;
      top: -15px !important;
    }
  }

  @media only screen and (max-height: 963px) {
    #glassContainer {
      width: 79px;
      height: 95px;
      top: 23%;
    }

    #EV_lens {
      left: -49px !important;
      top: -14px !important;
    }
  }

  @media only screen and (max-height: 926px) {
    #glassContainer {
      top: 210px;
    }
  }

  @media only screen and (min-height: 1270px) {
    #glassContainer {
      top: 18%;
      left: 55%
    }
  }

  @media only screen and (min-height: 1700px) {
    #glassContainer {
      top: 17%;
    }
  }

  #EV_lens {
    position: absolute;
    height: 135%;
    left: -69px;
    top: -18px;
  }

  
</style>

<div id="pageWrapper" style="visibility: hidden;">
  <div
    class="ModeViewerHolder"
    style="visibility: hidden; background: url({background}) no-repeat">
    <model-viewer
      id="unit01"
      src={model}
      class="model"
      environment-image={lights}
      shadow-color="#ff0066"
      alt="Evo Laptop"
      loading="lazy"
      exposure="0.9"
      auto-rotate="true"
      camera-controls
      autoplay="true"
      modelIsVisible
      field-of-view="40deg"
      interaction-prompt="none"
      auto-rotate-delay="5000"
      camera-orbit="330deg 78deg 160m"
      camera-target="0m 27.5m 0m"
      rotation-per-second="15%"
      on:model-visibility={isVisible}
      on:click={(e) => {
        if (e.target.id == 'unit01') {
          log2('rotation', '3d-rotation');
          loggin('rotation', '3d-rotation');
        }
      }}>
      {#if modelTime >= 1.5}
        <!-- Wake in a flash -->
        <button
          class="hotspot"
          slot="hotspot-1"
          alt="hotspot"
          data-position="28m 68m -44m"
          data-normal=".5m 3.56m 5m"
          data-visibility-attribute="visible"
          id="animation01">
          <div
            class="showDescriptionHandler"
            on:click={() => showDescriptionHandler(0)}
            on:mouseenter={hoverHandler}
            on:mouseleave={rollOutHandler}>
            <img
              class="img blue-checkmark noMouseInteraction"
              src={blueCheckmark}
              alt="close-device" />
            <img
              class="img white-checkmark noMouseInteraction"
              src={checkmark}
              alt="close-device" />
            <div class="circle scale-in-center noMouseInteraction" />

            {#if !(id == 0)}
              <div class="hotspot-copy">{hotspot[0].copy}</div>
            {/if}
          </div>
          {#if showDescription && id == 0}
            <HotspotConnectionLine
              width="116px"
              margin="53px 0px 0px 42px"
              rotate="rotate(35deg)" />
            <HotspotDescription
              title={hotspot[0].copy}
              subtitle={hotspot[0].description}
              thumbnail={hotspot[0].url.thumbnail}
              margin={'-15px 0px 0px 160px'}
              {backCopy}
              backArrowIcon={backArrow}
              on:close={closeDescriptionHandler}
              on:open-video={openVideoHandler}
              model={modelViewer}
              selectedCheckmark={blueCheckmark} />
          {/if}
        </button>
        <!-- Immersive viewing- -->
        <button
          class="hotspot"
          slot="hotspot-2"
          alt="hotspot"
          data-position="-28m 56m -43m"
          data-normal="-0.6m 1m 2m"
          data-visibility-attribute="visible"
          id="animation02">
          <div
            class="showDescriptionHandler"
            on:click={() => showDescriptionHandler(1)}
            on:mouseenter={hoverHandler}
            on:mouseleave={rollOutHandler}>
            <img
              class="img blue-checkmark noMouseInteraction"
              src={blueCheckmark}
              alt="close-device" />
            <img
              class="img white-checkmark noMouseInteraction"
              src={checkmark}
              alt="close-device" />
            <div class="circle scale-in-center noMouseInteraction" />

            {#if !(id == 1)}
              <div class="hotspot-left">{hotspot[1].copy}</div>
            {/if}
          </div>
          {#if showDescription && id == 1}
            <HotspotConnectionLine
              width="118px"
              margin="-53px 0px 0px -120px"
              rotate="rotate(30deg)" />
            <HotspotDescription
              title={hotspot[1].copy}
              subtitle={hotspot[1].description}
              thumbnail={hotspot[1].url.thumbnail}
              margin={'-122px 0px 0px -350px'}
              {backCopy}
              backArrowIcon={backArrow}
              on:close={closeDescriptionHandler}
              on:open-video={openVideoHandler}
              model={modelViewer}
              rightAligned="true"
              selectedCheckmark={blueCheckmark} />
          {/if}
        </button>
        <!--Get things done fast-->
        <button
          class="hotspot"
          slot="hotspot-3"
          alt="hotspot"
          data-position="40m 19.5m 4m"
          data-normal="0.6m 3.5m 0.2m"
          data-visibility-attribute="visible"
          id="animation03">
          <div
            class="showDescriptionHandler"
            on:click={() => showDescriptionHandler(2)}
            on:mouseenter={hoverHandler}
            on:mouseleave={rollOutHandler}>
            <img
              class="img blue-checkmark noMouseInteraction"
              src={blueCheckmark}
              alt="close-device" />
            <img
              class="img white-checkmark noMouseInteraction"
              src={checkmark}
              alt="close-device" />
            <div class="circle scale-in-center noMouseInteraction" />
            {#if !(id == 2)}
              <div class="hotspot-copy">{hotspot[2].copy}</div>
            {/if}
          </div>
          {#if showDescription && id == 2}
            <HotspotConnectionLine
              width="145px"
              margin="-77px 0px 0px -7px"
              rotate="rotate(-67deg)" />
            <HotspotDescription
              title={hotspot[2].copy}
              subtitle={hotspot[2].description}
              thumbnail={hotspot[2].url.thumbnail}
              margin={'-233px 0px 0px 110px'}
              {backCopy}
              backArrowIcon={backArrow}
              on:close={closeDescriptionHandler}
              on:open-video={openVideoHandler}
              model={modelViewer}
              selectedCheckmark={blueCheckmark} />
          {/if}
        </button>
        <!--unplug for longer-->
        <button
          class="hotspot"
          slot="hotspot-4"
          alt="hotspot"
          data-position="25m 14.5m 28m"
          data-normal="0m 0.5m 5m"
          data-visibility-attribute="visible"
          id="animation04">
          <div
            class="showDescriptionHandler"
            on:click={() => showDescriptionHandler(3)}
            on:mouseenter={hoverHandler}
            on:mouseleave={rollOutHandler}>
            <img
              class="img blue-checkmark noMouseInteraction"
              src={blueCheckmark}
              alt="close-device" />
            <img
              class="img white-checkmark noMouseInteraction"
              src={checkmark}
              alt="close-device" />
            <div class="circle scale-in-center noMouseInteraction" />

            {#if !(id == 3)}
              <div class="hotspot-left">{hotspot[3].copy}</div>
            {/if}
          </div>
          {#if showDescription && id == 3}
            <HotspotConnectionLine
              width="130px"
              margin="-40px 20px 0px 34px"
              rotate="rotate(-36deg)" />
            <HotspotDescription
              title={hotspot[3].copy}
              subtitle={hotspot[3].description}
              thumbnail={hotspot[3].url.thumbnail}
              margin={'-217px 0px 0px 170px'}
              {backCopy}
              backArrowIcon={backArrow}
              on:close={closeDescriptionHandler}
              on:open-video={openVideoHandler}
              model={modelViewer}
              selectedCheckmark={blueCheckmark} />
          {/if}
        </button>
        <!-- Fast, reliable connections -->
        <button
          class="hotspot"
          slot="hotspot-5"
          alt="hotspot"
          data-position="-50m 25m -35m"
          data-normal="-0.6m -0.3m 0.5m"
          data-visibility-attribute="visible"
          id="animation05">
          <div
            class="showDescriptionHandler"
            on:click={() => showDescriptionHandler(4)}
            on:mouseenter={hoverHandler}
            on:mouseleave={rollOutHandler}>
            <img
              class="img blue-checkmark noMouseInteraction"
              src={blueCheckmark}
              alt="close-device" />
            <img
              class="img white-checkmark noMouseInteraction"
              src={checkmark}
              alt="close-device" />
            <div class="circle scale-in-center noMouseInteraction" />
            {#if !(id == 4)}
              <div class="hotspot-left">{hotspot[4].copy}</div>
            {/if}
          </div>
          {#if showDescription && id == 4}
            <HotspotConnectionLine
              width="54px"
              margin="-22px 0px 0px -56px"
              rotate="rotate(41deg)" />
            <HotspotDescription
              title={hotspot[4].copy}
              subtitle={hotspot[4].description}
              thumbnail={hotspot[4].url.thumbnail}
              margin={'-204px 0px 0px -285px'}
              {backCopy}
              backArrowIcon={backArrow}
              on:close={closeDescriptionHandler}
              on:open-video={openVideoHandler}
              model={modelViewer}
              rightAligned="true"
              selectedCheckmark={blueCheckmark} />
          {/if}
        </button>
        <!-- Universal cable connectivity -->
        <button
          class="hotspot"
          slot="hotspot-6"
          alt="hotspot"
          data-position="-50m 11.5m -20m"
          data-normal="-0.6m 0m 0.5m"
          data-visibility-attribute="visible"
          id="animation06">
          <div
            class="showDescriptionHandler"
            on:click={() => showDescriptionHandler(5)}
            on:mouseenter={hoverHandler}
            on:mouseleave={rollOutHandler}>
            <img
              class="img blue-checkmark noMouseInteraction"
              src={blueCheckmark}
              alt="close-device" />
            <img
              class="img white-checkmark noMouseInteraction"
              src={checkmark}
              alt="close-device" />
            <div class="circle scale-in-center noMouseInteraction" />
            {#if !(id == 5)}
              <div class="hotspot-left">{hotspot[5].copy}</div>
            {/if}
          </div>
          {#if showDescription && id == 5}
            <HotspotConnectionLine
              width="153px"
              margin="-27px 0px 0px -157px"
              rotate="rotate(25deg)" />
            <HotspotDescription
              title={hotspot[5].copy}
              subtitle={hotspot[5].description}
              thumbnail={hotspot[5].url.thumbnail}
              margin={'-266px 0px 0px -394px'}
              {backCopy}
              backArrowIcon={backArrow}
              on:close={closeDescriptionHandler}
              on:open-video={openVideoHandler}
              model={modelViewer}
              rightAligned="true"
              selectedCheckmark={blueCheckmark} />
          {/if}
        </button>
      {/if}
    </model-viewer>
  </div>
</div>
<!-- ANIMATION Zoom -->
<div
  id="animZoom"
  class="noMouseInteraction overlaysFXs"
  data-visibility-attribute="visible">
  <div id="glassContainer">
    <img id="shadow" src={zoomifyGlassShadow} alt="zoomifyShadow" />
    <div id="InmersiveContainer">
      <img id="EV_Inmersive" src={landscapeImg} alt="EV_Inmersive" />
    </div>
    <img id="EV_lens" src={zoomifyGlass} alt="EV_lens" />
  </div>
</div>
